import { get } from 'lodash';
import React from 'react';
import { Field, FastField, FieldProps } from 'formik';

import { useRegisteredRef } from 'src/lib/react-register-nodes';
import { StyledCheckbox, StyledCheckboxProps } from 'src/kit';
import { FormikErrorMessage } from './FormikErrorMessage';

export type FormikCheckboxProps = Omit<StyledCheckboxProps, 'checked'> & {
  name: string;
  isFast?: boolean;
};

const FormikCheckbox = ({ isFast, name, children, ...rest }: FormikCheckboxProps) => {
  const FormikField = isFast ? FastField : Field;
  const ref = useRegisteredRef(name);

  return (
    <FormikField name={name}>
      {({ field: { value, onBlur }, form: { touched, errors, setFieldValue } }: FieldProps) => {
        const error = get(touched, name) && get(errors, name);

        return (
          <StyledCheckbox
            ref={error ? ref : undefined}
            name={name}
            checked={Boolean(value)}
            onChange={event => setFieldValue(name, event.target.checked)}
            onBlur={onBlur}
            {...rest}
          >
            {children}
            <FormikErrorMessage name={name} />
          </StyledCheckbox>
        );
      }}
    </FormikField>
  );
};

export default FormikCheckbox;
